
export enum dashboardStorageKey {
    AdminComplianceContentSelection = 'AdminComplianceContentSelection',
    AdminCompliancePagination = 'AdminCompliancePagination',
    AllItemsContentSelection = 'AllItemsContentSelection',
    AllItemsPagination = 'AllItemsPagination'
}